//this will be used later in app, for avoiding checking function existence, just giving as default value noop

const noop = () => {};

export default noop;
